import { render, staticRenderFns } from "./FinanceClientsBankDetails.vue?vue&type=template&id=51fb62de"
import script from "./FinanceClientsBankDetails.vue?vue&type=script&lang=js"
export * from "./FinanceClientsBankDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports